module.exports = require("proper-lockfile");